module.exports = __webpack_public_path__ + "static/media/openflow.1d50979f.png";